export const countAppliedFilters = form =>
  Object.values(form).reduce(
    (acc, curr) => (Array.isArray(curr) ? [...acc, ...curr] : [...acc, curr]),
    []
  ).length;
